/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

window.showCircleChart = function(chart_element,value,title){
    Highcharts.chart(chart_element, {
          chart: {
            type: 'solidgauge',
            marginTop: 10,
            color: "#000000"
          },
          title: {
            text: title,
            style: {
              fontSize: '15px',
              color: '#666666'
            },
            y: 280
          },
          tooltip: {
            borderWidth: 0,
            backgroundColor: 'none',
            shadow: false,
            visible: false,
            style: {
              fontSize: '0px'
            },
            pointFormat: '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}%</span>',
            positioner: function (labelWidth) {
              return {
                x: 200 - labelWidth / 2,
                y: 180
              };
            }
          },
          pane: {
            startAngle: 0,
            endAngle: 360,
            background: [{// Track for Move
                outerRadius: '80%',
                innerRadius: '85%',
                backgroundColor: '#eeeeee',
                borderWidth: 0
              }]
          },
          yAxis: {
            min: 0,
            max: 100,
            lineWidth: 0,
            tickPositions: []
          },
          plotOptions: {
            solidgauge: {
              dataLabels: {
                enabled: true,
                format: '{y}%',
                x: 15,
                style: {
                  fontSize: '25px', // Larger font size for better visibility
                  color: '#333333', // Darker color for contrast
                  fontWeight: 'bold'
                }
              },
              linecap: 'round',
              stickyTracking: false,
              rounded: true
            }
          },
          series: [{
              name: ' ',
              borderColor: '#2b7fff',
              data: [{
                  color: '#2b7fff',
                  radius: '85%',
                  innerRadius: '80%',
                  y: parseInt(value)
                }]
            }]
        }
  );
}